<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header" style="display: flex; align-items: center; justify-content: space-between; flex-wrap: nowrap; padding:32px;">
            <h4 style="margin: 0; font-size: 16px;">Send Counter Offer to {{ negotiation.carrier.name }}</h4>
            <button @click="onClose" type="button" class="close" style="margin: 0; padding: 0; line-height: 1; align-self: center;">×</button>
          </div>
          <div class="modal-body" style="gap: 8px; padding:32px;">
            <div v-if="errors.generalError" class="alert alert-danger mb-3">{{ errors.generalError }}</div>

            <form @submit.prevent="submit()">

              <!-- Block 1: Price -->
              <div class="mb-3 bgColor" style="padding: 16px; border-radius: 4px;">
                <div class="d-flex" style="gap: 8px; align-items: center;">
                  <div style="font-size: 16px; font-weight: bold;">Price:
                  <span style="font-size: 14px;">${{ displayPrice }}</span>
                  </div>
                </div>
                <div class="d-flex flex-wrap mt-3" style="gap: 8px;">
                  <RoundedButton
                    v-for="opt in priceOptions"
                    :key="opt.key"                                              
                    type="form"
                    :active="selectedPriceKey === opt.key"
                    @click="selectPrice(opt)"
                  >$ {{ opt.label }}</RoundedButton>
                  <div class="custom-input-wrapper" :class="{ 'custom-input-active': !selectedPriceKey && form.carrierPay !== '' }">
                    <span class="custom-input-prefix">$</span>
                    <input
                      v-model.number="form.carrierPay"
                      type="number"
                      step="1"
                      min="0"
                      placeholder="Custom price"
                      class="custom-input"
                    />
                  
                  <div v-if="errors.carrier_pay" class="invalid-feedback d-block">{{ errors.carrier_pay[0] }}</div>
                </div>
                </div>

              </div>

              <!-- Block 2: Pickup Date -->
              <div class="mb-3 bgColor" style="padding: 16px; border-radius: 4px;">
                <div class="d-flex" style="gap: 8px; align-items: center; font-weight: bold;">
                  <div style="font-size: 16px;">Pick Up Date: 
                  <span v-if="negotiation.pickupDateType" style="font-size: 14px;">{{ negotiation.pickupDateType.title }}</span>
                  <span style="font-size: 14px;">{{ displayPickupDate }}</span>
                  </div>
                </div>
                <div class="d-flex flex-wrap mt-3" style="gap: 8px; align-items: center;">
                  <RoundedButton
                    type="form"
                    :active="selectedPickupKey === 'preset'"
                    @click="selectedPickupKey = 'preset'; form.pickupDate = ''"
                  >{{ pickupPresetFormatted }}</RoundedButton>
                  <input
                    v-model="form.pickupDate"
                    type="date"
                    class="custom-input"
                    :class="{ 'custom-input-active': !selectedPickupKey && form.pickupDate }"
                  />
                  <div v-if="errors.pickup_date" class="invalid-feedback d-block w-100">{{ errors.pickup_date[0] }}</div>
                </div>
              </div>

              <!-- Block 3: Delivery Date -->
              <div class="mb-3 bgColor" style="padding: 16px; border-radius: 4px;">
                <div class="d-flex" style="gap: 8px; align-items: center; font-weight: bold;">
                  <div style="font-size: 16px; ">Delivery Date: 
                    <span v-if="negotiation.deliveryDateType" style="font-size: 14px;">{{ negotiation.deliveryDateType.title }}</span>
                    <span style="font-size: 14px;">{{ displayDeliveryDate }}</span>
                  </div>
                </div>
                <div class="d-flex flex-wrap mt-3" style="gap: 8px; align-items: center;">
                  <RoundedButton
                    type="form"
                    :active="selectedDeliveryKey === 'today'"
                    @click="selectedDeliveryKey = 'today'; form.deliveryDate = ''"
                  >{{ todayFormatted }}</RoundedButton>
                  <input
                    v-model="form.deliveryDate"
                    type="date"
                    class="custom-input"
                    :class="{ 'custom-input-active': !selectedDeliveryKey && form.deliveryDate }"
                  />
                  <div v-if="errors.delivery_date" class="invalid-feedback d-block w-100">{{ errors.delivery_date[0] }}</div>
                </div>
              </div>

              <!-- Block 4: Trailer -->
              <div class="mb-3 bgColor" style="padding: 16px; border-radius: 4px;">
                <div class="d-flex" style="gap: 8px; align-items: center;">
                  <div style="font-size: 16px; font-weight: bold;">Trailer:
                  <span v-if="form.trailerType" style="font-size: 14px;">{{ trailerOptions.find(t => t.value === form.trailerType).label }}</span>
                  </div>
                </div>
                <div class="d-flex flex-wrap mt-3" style="gap: 8px;">
                  <RoundedButton
                    v-for="t in trailerOptions"
                    :key="t.value"
                    type="form"
                    :active="form.trailerType === t.value"
                    @click="form.trailerType = t.value"
                  >{{ t.label }}</RoundedButton>
                </div>
              </div>

              <!-- Block 4: Expiration -->
              <div class="mb-3 bgColor" style="padding: 16px; border-radius: 4px;">
                <div class="d-flex" style="gap: 8px; align-items: center;">
                  <div style="font-size: 16px; font-weight: bold;">Expiration:
                  <span v-if="displayExpiresAt" style="font-size: 14px;">{{ displayExpiresAt }}</span>
                  </div>
                </div>
                <div class="d-flex flex-wrap mt-3" style="gap: 8px; align-items: center;">
                  <RoundedButton
                    v-for="opt in expiryOptions"
                    :key="opt.text"
                    type="form"
                    :active="selectedExpiryKey === opt.text"
                    @click="selectedExpiryKey = opt.text; form.expiresAt = ''"
                  >{{ opt.text }}</RoundedButton>
                </div>
              </div>  


              <!-- Block 5: Notes -->
              <div class="mb-3 bgColor" style="padding: 16px; border-radius: 4px;">
                <div style="font-size: 16px; font-weight: bold;">Notes</div>
                <div class="mt-3">
                  <b-textarea
                    v-model="form.note"
                    placeholder="Add a note to the carrier..."
                    rows="3"
                  />
                </div>
              </div>

              <div class="d-flex justify-content-end" style="gap: 8px;">
                <button type="button" class="btn btn-secondary" @click="onClose">Cancel</button>
                <button class="btn btn-primary" type="submit" :disabled="formSubmit || isExpired">
                  {{ formSubmit ? 'Sending...' : 'Send Counter Offer' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import RoundedButton from '@/components/shared/RoundedButton.vue';

export default {
  name: 'CounterOfferHCLDesignModal',
  components: { RoundedButton },
  props: {
    order: {
      type: Object,
      required: true,
    },
    negotiation: {
      type: Object,
      required: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formSubmit: false,
      errors: {},
      selectedPriceKey: null,
      selectedPickupKey: this.negotiation.pickupDate ? 'preset' : null,
      selectedDeliveryKey: null,
      selectedExpiryKey: null,
      expiryOptions: [
        { text: 'No Expiry', value: null },
        { text: '30m', value: 30 },
        { text: '3h', value: 180 },
        { text: '6h', value: 360 },
        { text: '12h', value: 720 },
        { text: '24h', value: 1440 },
        { text: '2 days', value: 2880 },
      ],
      form: {
        carrierPay: this.negotiation.carrierOffer || '',
        pickupDate: '',
        trailerType: null,
        deliveryDate: '',
        expiresAt: '',
        note: '',
      },
      trailerOptions: [
        { value: 'open',     label: 'Open'     },
        { value: 'enclosed', label: 'Enclosed' },
      ],
      expirationConfig: {
        inline: false,
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        altInput: true,
        altFormat: 'm/d/Y h:i K',
        allowInput: false,
      },
    };
  },
  computed: {
    todayDate() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    todayFormatted() {
      const d = new Date();
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    },
    isExpired() {
      if (!this.negotiation.expiresAt) return false;
      return new Date(this.negotiation.expiresAt) < new Date();
    },
    basePrice() {
      return parseFloat(this.negotiation.carrierOffer) || 0;
    },
    priceOptions() {
      return [
        { key: 'plus50',  label: this.basePrice + 50,    amount: this.basePrice + 50  },
        { key: 'plus100', label: this.basePrice + 100,   amount: this.basePrice + 100 },
        { key: 'plus150', label: this.basePrice + 150,   amount: this.basePrice + 150 },
      ];
    },
    displayPrice() {
      const opt = this.priceOptions.find(o => o.key === this.selectedPriceKey);
      if (opt) return opt.amount;
      return this.form.carrierPay || this.basePrice;
    },
    pickupPreset() {
      return this.negotiation.pickupDate || this.todayDate;
    },
    pickupPresetFormatted() {
      return this.formatDate(this.pickupPreset);
    },
    displayPickupDate() {
      if (this.selectedPickupKey === 'preset') return this.pickupPresetFormatted;
      if (this.form.pickupDate) return this.formatDate(this.form.pickupDate);
      return '';
    },
    displayExpiresAt() {
      if (this.selectedExpiryKey) {
        const opt = this.expiryOptions.find(o => o.text === this.selectedExpiryKey);
        return opt ? opt.text : '';
      }
      return this.form.expiresAt || '';
    },
    displayDeliveryDate() {
      if (this.selectedDeliveryKey === 'today') return this.todayFormatted;
      if (this.form.deliveryDate) return this.formatDate(this.form.deliveryDate);
      return '';
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [y, m, d] = dateStr.split('-');
      return `${parseInt(m)}/${parseInt(d)}/${y}`;
    },
    selectPrice(opt) {
      this.selectedPriceKey = opt.key;
      this.form.carrierPay = '';
    },
    async submit() {
      if (this.isExpired) {
        this.errors = { generalError: 'This offer has expired and cannot be countered.' };
        return;
      }
      this.formSubmit = true;
      this.errors = {};
      const response = await ApiClient.leads.offers.counter({
        leadId: this.order.id,
        id: this.negotiation.id,
        body: {
          carrier_pay: Math.round(parseFloat(this.displayPrice)),
          pickup_date: this.selectedPickupKey === 'preset' ? this.pickupPreset : this.form.pickupDate,
          delivery_date: this.selectedDeliveryKey === 'today' ? this.todayDate : this.form.deliveryDate || undefined,
          trailer_type: this.form.trailerType || undefined,
          expires_at: (() => {
            if (this.selectedExpiryKey === 'No Expiry') return undefined;
            if (this.selectedExpiryKey) {
              const opt = this.expiryOptions.find(o => o.text === this.selectedExpiryKey);
              if (opt && opt.value) {
                const d = new Date();
                d.setMinutes(d.getMinutes() + opt.value);
                return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
              }
            }
            return this.form.expiresAt || undefined;
          })(),
          note: this.form.note || undefined,
        },
      });
      if (response.status === 200) {
        this.$emit('refresh');
        this.onClose();
      } else if (response.status === 400) {
        this.errors = { generalError: response.data.message };
      } else if (response.status === 422) {
        this.errors = response.data.errors;
      } else {
        this.errors = { generalError: 'An error occurred. Please try again.' };
      }
      this.formSubmit = false;
    },
  },
  watch: {
    'form.carrierPay'(val) {
      if (val) this.selectedPriceKey = null;
    },
    'form.pickupDate'(val) {
      if (val) this.selectedPickupKey = null;
      this.expirationConfig.minDate = val || this.todayDate;
    },
    'form.deliveryDate'(val) {
      if (val) this.selectedDeliveryKey = null;
    },
    'form.expiresAt'(val) {
      if (val) this.selectedExpiryKey = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}

.bgColor{
  background-color: #EBEEF5;
}
.dark-style .bgColor{
  background-color: #393B40;
}
.custom-input-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.custom-input-prefix {
  position: absolute;
  left: 10px;
  font-size: 13px;
  color: #4E5155;
  pointer-events: none;
}

.dark-style .custom-input-prefix {
  color: #B3B4B4;
}

.custom-input {
  border-radius: 100px;
  padding: 0 8px 0 20px;
  height: 30px;
  border: 1px solid #AEB3B8;
  color: #4E5155;
  background-color: transparent;
  width: 150px;
  outline: none;
}

.dark-style .custom-input {
  color: #B3B4B4;
}

.custom-input-active .custom-input,
.custom-input.custom-input-active {
  color: white;
  background-color: #3E4144;
  border-color: #52565B;
}

.custom-input-active .custom-input-prefix {
  color: white;
}

.dark-style .custom-input-active .custom-input,
.dark-style .custom-input.custom-input-active {
  color: #26282D;
  background-color: #C1C1C1;
  border-color: #AEB3B8;
}

.dark-style .custom-input-active .custom-input-prefix {
  color: #26282D;
}
</style>
